import React, 
     { useState , 
       useEffect,
       useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import Radio             from '@mui/material/Radio'
import RadioGroup        from '@mui/material/RadioGroup'
import FormControlLabel  from '@mui/material/FormControlLabel'
import ArrowForwardIcon  from '@mui/icons-material/ArrowForward'
import DirectionalPadKey from './GB_DirectionalPadKey'
import store             from '../../store'
import '../../App.css'
import '../../style.css';

// --------------------定数---------------------
export const baseId  = "molecule-game-boy-logo"

function GakunenSelect() {
  const [selectedLabel, setSelectedLabel] = useState(store.getState().GakunenSelect) // ラジオボタンの選択されたラベルを管理

  // ラジオボタンの選択が変更された時の処理
  const handleRadioChange = (event) => {
    setSelectedLabel(event.target.value) // ラジオボタンが変更されたときに選択されたラベルを更新
    store.getState().GakunenSelect = event.target.value
    console.log("選択中の学年:",selectedLabel)
  }
  
  useEffect(() => {
    console.log("選択中の学年=>",store.getState().GakunenSelect)
  }, [])

  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* 画面 */}
        <Paper sx={{ m: 1, p: 1 ,
                bgcolor      : '#f5f5dc'  ,
                borderRadius : "1px"      , 
                height       : "250px"    ,
                width        : '250px'    ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '40px'     , // 横位置を20pxに指定
        }}>
          <Grid container spacing={0}>
            {/* タイトル表示 */}
            <Grid item xs={12} align="center">
              <Typography
                  sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "24px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                  }}>がくねんをせんたく</Typography>
            </Grid>

          {/* 選択欄表示 */}
          <Grid item xs={12} align="center">
            <Box
              sx={{
                // 独自フォントに設定
                fontFamily   : 'DotGothic16'   , // フォント
                color        : '#000000'       , // フォントの色を黒に設定
                border       : '3px solid #696969', // 枠線の太さと色を設定
                borderRadius : '5px'           , // 角丸の半径を設定
                padding      : '0 5px'         , // 上下0px、左右20pxの余白を設定
                top          : '75px'          , // 縦位置を指定
                left         : '5px'           , // 横位置を指定
                position     : 'absolute'      , // 絶対位置指定
                width        : '91%'           , // 横幅を50%に設定（例）
              }}>
              <RadioGroup 
                defaultValue="1" 
                name="radio-buttons-group"
                value={selectedLabel} 
                onChange={handleRadioChange}>
                <Grid container spacing={0}>
                  <Grid item xs={6}>
                    <FormControlLabel 
                      autoFocus
                      value="1" 
                      control={<Radio 
                                autoFocus
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="1ねんせい" 
                      sx={{ marginBottom: '-3px'
                      }} // ラベルの下マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                    <FormControlLabel 
                      value="2" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="2ねんせい" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                    <FormControlLabel 
                      value="3" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="3ねんせい" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel 
                      value="4" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="4ねんせい" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                    <FormControlLabel 
                      value="5" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="5ねんせい" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                    <FormControlLabel 
                      value="6" 
                      control={<Radio 
                                icon={<ArrowForwardIcon style={{ color: '#f5f5dc' }} />} 
                                checkedIcon={<ArrowForwardIcon style={{ color: '#000000' }} />} 
                              />} // 選択している要素の色を指定
                      label="6ねんせい" 
                      sx={{ marginTop: '-3px' }} // ラベルの上マージンを調整
                      tabIndex={0} // キーボードフォーカス可能にする
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </Box>
          </Grid>

          {/* メッセージ欄表示 */}
          <Grid 
            item xs={12} 
            align="center"
            sx={{
              border       : '3px solid #696969', // 枠線の太さと色を設定
              borderRadius : '5px'           , // 角丸の半径を設定
              padding      : '0 5px'         , // 上下0px、左右20pxの余白を設定
              top          : '200px'         , // 縦位置を指定
              left         : '5px'           , // 横位置を指定
              position     : 'absolute'      , // 絶対位置指定
              width        : '96%'           , // 外枠の幅を指定
              height       : '23%'           , // 外枠の高さを指定
              }}>
              <Typography
                sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // フォント
                  fontSize     : "12px"          , 
                  color        : '#000000'       , // フォントの色を黒に設定
                  }}
                tabIndex={0} // キーボードフォーカス可能にする
                >がくねんをえらんでね<br />
                1.↑↓でえらぶ<br />
                2.Aボタンでけってい</Typography>
          </Grid>
        </Grid>
      </Paper>
    <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
    </Grid>
  </Box>
  );
}

export default GakunenSelect
